<template>
  <div>
    <!-- 表格有数据 -->
    <div v-if="isShow" class="hasData">
      <el-table
        ref="multipleTable"
        v-loading="loading"
        :cell-style="{ color: '#666666' }"
        :data="list"
        :header-cell-style="{ color: '#64C3A4', fontSize: '16px' }"
        :row-class-name="TableRow"
        empty-text=" "
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="种源名称" prop="productName" />
        <el-table-column label="审定编号" prop="productCode" width="90" />
        <el-table-column label="所属作物品种" prop="cropName">
          <template slot-scope="scope">
            <span>{{ scope.row.cropName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="规格">
          <template slot-scope="scope">
            <span>{{
              scope.row.unit
                ? scope.row.unit +
                  scope.row.meterUnitName +
                  "/" +
                  scope.row.packUnitName
                : "--"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否上链">
          <template slot-scope="scope">
            <span>{{ scope.row.blockMark ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="数量" prop="quantity" width="90">
          <template slot-scope="scope">
            <div class="date-icon">
              <span>{{ scope.row.quantity || "--" }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量单位" prop="packUnitName" width="120">
          <template slot-scope="scope">
            <div class="date-icon">
              <span>{{ scope.row.packUnitName || "--" }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="购买时间" width="120">
          <template slot-scope="scope">
            <div class="date-icon">
              <span>{{
                scope.row.buyDate || "--" | formatDate("yyyy-MM-dd")
              }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="购买人" prop="purchaser" width="150">
          <template slot-scope="scope">
            <div class="date-icon">
              <span>{{ scope.row.purchaser || "--" }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100px">
          <template slot-scope="scope">
            <span
              v-if="isShowEdit"
              class="operate-btn"
              @click="editFarming(scope.row.id)"
              ><i class="el-icon-edit"></i
            ></span>
            <span
              v-if="isShowDel"
              class="operate-btn"
              @click="deleteData(scope.row.id)"
              ><i class="el-icon-delete"></i
            ></span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 表格无数据 -->
    <div v-else class="noDataImg">
      <div class="imgNo">
        <img alt="" src="~@/assets/images/aviatFarmingList/batch-nodata.png" />
      </div>
      <p style="color: #333; margin-bottom: 20px">暂无种源数据</p>
    </div>
  </div>
</template>

<script>
import sameIn from "@/mixins/listsdetails.js";
import { mapActions } from "vuex";
// import { windowHref } from "@/utils/index";
import { deleteByIds } from "@/api/request/snkd.produce";

export default {
  name: "TableList",
  mixins: [sameIn],
  data() {
    return {
      //是否显示编辑按钮
      isShowEdit: false,
      //是否显示删除按钮
      isShowDel: false,
    };
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  filters: {
    formatArgic(val) {
      if (!val.agriList || !val.agriList.length) {
        return "--";
      } else {
        let data = val.agriList[0];
        return (
          data.agriResName + " " + data.dose + " " + data.agriResMeterUnitName
        );
      }
    },
  },
  async mounted() {
    await this.fnHasPermission();
  },
  methods: {
    ...mapActions("permission", ["hasPermission"]),
    //判断按钮是否有权限
    async fnHasPermission() {
      //删除
      this.isShowDel = await this.hasPermission(
        "produce:navigateCultivate:del"
      );
      //编辑
      this.isShowEdit = await this.hasPermission(
        "produce:navigateCultivate:edit"
      );
    },
    editFarming(id) {
      this.$router.push({
        path: "/addSeedSource",
        query: {
          id: id,
        },
      });
    },
    deleteData(id) {
      const h = this.$createElement;
      this.$confirm("", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "confirm-dialog",
        message: h("div", [
          h(
            "p",
            {
              style:
                "font-size: 16px;margin-bottom:12px;color: rgba(0, 0, 0, 0.85);font-weight:400;",
            },
            `是否确定删除此条数据？`
          ),
          h(
            "p",
            {
              style:
                "font-size: 14px;color: rgba(0, 0, 0, 0.65);font-weight:400;",
            },
            [h("span", null, "删除后的数据将无法恢复。")]
          ),
        ]),
        type: "warning",
      })
        .then(async () => {
          await deleteByIds({
            ids: [id],
          }).then((res) => {
            const { respCode } = res;
            if (respCode === 0) {
              this.$message({
                type: "success",
                message: "删除成功！",
              });
              this.$emit("updateList");
            }
          });
        })
        .catch(() => {});
    },
    handleSelectionChange(rows) {
      this.$emit("selectListChange", rows);
    },
    goArigicRecordPage() {
      // windowHref("/home/batch", {
      //   companyId: this.companyId,
      //   farmId: this.farmId,
      //   tab: 1,
      //   periodType: 2,
      //   source: "hangyu",
      // });
      window.open(
        window.location.origin +
          `/index.html#/home/batch/company=${this.companyId}&farm=${this.farmId}&tab=1&periodType=2&source=hangyu`
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.hasData {
  height: 100%;
  padding: 12px;

  .operate-btn {
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
    font-size: 16px;
  }

  .date-icon {
    display: flex;
    align-items: center;

    .el-icon-warning {
      margin-left: 6px;
      font-size: 22px;
      color: #e6a23c;
    }

    .err-txt {
      color: red;
    }
  }

  ::v-deep .table-txt {
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden; //溢出内容隐藏
    text-overflow: ellipsis; //文本溢出部分用省略号表示
    display: -webkit-box; //特别显示模式
    -webkit-line-clamp: 2; //行数
    line-clamp: 2;
    -webkit-box-orient: vertical; //盒子中内容竖直排列
  }
}
</style>
